import { Event } from '../../models/event/event';
import { Injectable } from '@angular/core';

import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse} from '@angular/common/http';

import {Observable, throwError, BehaviorSubject } from 'rxjs';
import {catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {httpOptions} from '../../configurations/configuration';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  baseURI = environment.baseURI; 
  apiUrl = environment.apiUrl;
  createEvent = environment.createEventUrl;
  getEventDetails = environment.getEventDetails;
  updateEventSpeakerUrl = environment.updateEventSpeakerUrl;
  updateEventVenueUrl= environment.updateEventVenueUrl;
  submitEventUrl= environment.submitEventUrl;
  sendAttendeeEventReminderUrl= environment.sendAttendeeEventReminderUrl;
  updateEventUrl = environment.updateEventUrl;
  deleteEventUrl = environment.deleteEventUrl;
  updateEventStatusUrl = environment.updateEventStatusUrl;
  getAllEventStatusUrl = environment.getAllEventStatusUrl;
  micrositeQuestionOptionsUrl = environment.micrositeQuestionOptionsUrl;

  constructor(private http: HttpClient) { }


  create (postBody: any): Observable<Event> {
    return this.http.post<Event>(this.baseURI+this.apiUrl+this.createEvent, postBody, httpOptions);
  }  

  update(postBody: any): Observable<Event> {
    return this.http.post<Event>(this.baseURI+this.apiUrl+this.updateEventUrl, postBody, httpOptions);
  }  

  delete(postBody: any): Observable<Event> {
    return this.http.post<Event>(this.baseURI+this.apiUrl+this.deleteEventUrl, postBody, httpOptions);
  }  

  getEventById(event_id): Observable<Event> {
    return this.http.get<Event>(this.baseURI + this.apiUrl + this.getEventDetails+ event_id);
  }

  updateEventSpeaker(postBody): Observable<any> {
    return this.http.post<any>(this.baseURI+this.apiUrl+this.updateEventSpeakerUrl, postBody, httpOptions);
  }

  updateEventVenue(postBody): Observable<any> {
    return this.http.post<any>(this.baseURI+this.apiUrl+this.updateEventVenueUrl, postBody, httpOptions);
  }

  updateEventStatus(postBody): Observable<any> {
    return this.http.post<any>(this.baseURI+this.apiUrl+this.updateEventStatusUrl, postBody, httpOptions);
  }

  getEventStatus(): Observable<Event> {
    return this.http.get<Event>(this.baseURI + this.apiUrl + this.getAllEventStatusUrl);
  }

  submit(postBody): Observable<any> {
    return this.http.post<any>(this.baseURI+this.apiUrl+this.submitEventUrl, postBody, httpOptions);
  }

  sendAttendeeInvite(postBody): Observable<any> {
    return this.http.post<any>(this.baseURI+this.apiUrl+this.sendAttendeeEventReminderUrl, postBody, httpOptions);
  }

  micrositeQuestionOptions(filterObj): Observable<any> {
    return this.http.get<any>(this.baseURI +this.micrositeQuestionOptionsUrl+ '?filter=' + encodeURIComponent(JSON.stringify(filterObj)));
  }


}
